import React from 'react';

const UploadFileImage = () => (
    <svg
        width='97'
        height='90'
        viewBox='0 0 97 90'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clip-path='url(#clip0_1704_2761)'>
            <rect
                width='96'
                height='89.4757'
                transform='translate(0.5)'
                fill='white'
                fill-opacity='0.01'
            />
            <path
                d='M73.9804 32.3131H32.4424C24.2299 32.3131 26.5207 25.4967 18.4379 25.4967H3.35277C2.59222 25.508 1.86667 25.8176 1.33288 26.3584C0.799087 26.8993 0.499915 27.628 0.5 28.3872L0.5 89.4757H76.8764V35.1604C76.8764 34.7829 76.8013 34.409 76.6552 34.0607C76.5091 33.7124 76.2951 33.3966 76.0256 33.1316C75.7561 32.8667 75.4365 32.6578 75.0854 32.5173C74.7343 32.3768 74.3587 32.3074 73.9804 32.3131Z'
                fill='#3384FF'
            />
            <path
                d='M0.5 89.4757H51.8498L21.2474 43.0553C15.5761 43.4208 10.1497 45.4969 5.68685 49.0088C3.72932 50.5726 1.98553 52.3856 0.5 54.4015L0.5 89.4757Z'
                fill='#0065FF'
            />
            <path
                d='M30.9295 70.8817H14.8071V72.6074H30.9295V70.8817Z'
                fill='#0065FF'
            />
            <path
                d='M40.5252 12.9425H20.9449V14.6682H40.5252V12.9425Z'
                fill='#6BD5E5'
            />
            <path
                d='M52.1524 6.47119H14.8071V8.19686H52.1524V6.47119Z'
                fill='#0065FF'
            />
            <path
                d='M53.8382 25.885H34.2578V27.6107H53.8382V25.885Z'
                fill='#0065FF'
            />
            <path
                d='M25.3969 0H14.8071V1.72567H25.3969V0Z'
                fill='#99C1FF'
            />
            <path
                d='M31.5347 19.4137H20.9449V21.1394H31.5347V19.4137Z'
                fill='#99C1FF'
            />
            <path
                d='M11.1763 0H8.75574V1.72567H11.1763V0Z'
                fill='#CFD4DB'
            />
            <path
                d='M11.1763 6.47119H8.75574V8.19686H11.1763V6.47119Z'
                fill='#CFD4DB'
            />
            <path
                d='M11.1763 12.9425H8.75574V14.6682H11.1763V12.9425Z'
                fill='#CFD4DB'
            />
            <path
                d='M11.1763 19.4137H8.75574V21.1394H11.1763V19.4137Z'
                fill='#CFD4DB'
            />
            <path
                d='M11.1763 25.583H8.75574V27.3087H11.1763V25.583Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 32.3993H8.75574V34.125H11.1763V32.3993Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 38.8706H8.75574V40.5963H11.1763V38.8706Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 45.3418H8.75574V47.0675H11.1763V45.3418Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 51.8131H8.75574V53.5388H11.1763V51.8131Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 58.2844H8.75574V60.0101H11.1763V58.2844Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 64.7556H8.75574V66.4813H11.1763V64.7556Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 71.2268H8.75574V72.9525H11.1763V71.2268Z'
                fill='#FAFBFC'
            />
            <path
                d='M11.1763 77.6981H8.75574V79.4238H11.1763V77.6981Z'
                fill='#FAFBFC'
            />
            <path
                d='M69.9174 32.3993H33.4797V34.125H69.9174V32.3993Z'
                fill='#FDC150'
            />
            <path
                d='M29.8057 32.3993H20.4261V34.125H29.8057V32.3993Z'
                fill='#3DC7DC'
            />
            <path
                d='M69.9174 38.2235H41.649V39.9492H69.9174V38.2235Z'
                fill='#0065FF'
            />
            <path
                d='M37.975 38.2235H20.4261V39.9492H37.975V38.2235Z'
                fill='#FDC150'
            />
            <path
                d='M64.0389 45.3418H14.9367V47.0675H64.0389V45.3418Z'
                fill='#3DC7DC'
            />
            <path
                d='M51.9363 51.8131H15.6715V53.5388H51.9363V51.8131Z'
                fill='#3DC7DC'
            />
            <path
                d='M42.9457 64.7556H14.8071V66.4813H42.9457V64.7556Z'
                fill='#FAFBFC'
            />
            <path
                d='M52.1092 58.2844H35.9867V60.0101H52.1092V58.2844Z'
                fill='#0065FF'
            />
            <path
                d='M69.9174 19.4137H33.8687V21.1394H69.9174V19.4137Z'
                fill='#FDC150'
            />
            <path
                d='M76.8764 89.4757H0.5L20.6855 44.2633C20.8491 43.907 21.1105 43.6044 21.4395 43.3906C21.7685 43.1768 22.1516 43.0605 22.5441 43.0553H94.4253C94.7687 43.0559 95.1066 43.1415 95.4086 43.3045C95.7107 43.4676 95.9675 43.7029 96.156 43.9894C96.3446 44.2759 96.4589 44.6046 96.4887 44.9461C96.5186 45.2875 96.463 45.631 96.3271 45.9458L76.8764 89.4757Z'
                fill='#66A3FF'
            />
            <path
                d='M58.3801 77.333C67.5777 70.3143 71.3667 59.8371 66.8429 53.9315C62.3192 48.026 51.1958 48.9284 41.9982 55.9471C32.8006 62.9658 29.0117 73.443 33.5354 79.3486C38.0592 85.2542 49.1825 84.3518 58.3801 77.333Z'
                fill='#3384FF'
            />
            <path
                d='M40.871 73.6428C40.7225 73.6365 40.5778 73.5938 40.4497 73.5186C40.3216 73.4433 40.2139 73.3379 40.1362 73.2114L36.4622 67.1284C36.408 67.035 36.3729 66.9318 36.3588 66.8248C36.3447 66.7178 36.3519 66.6091 36.38 66.5049C36.4082 66.4006 36.4566 66.303 36.5226 66.2175C36.5887 66.132 36.6709 66.0604 36.7648 66.0068L45.8418 59.9238C46.0309 59.7922 46.2647 59.741 46.4916 59.7815C46.7186 59.8219 46.9202 59.9507 47.052 60.1395C47.1839 60.3283 47.2351 60.5616 47.1946 60.7881C47.1541 61.0147 47.0251 61.2159 46.8359 61.3475L38.4073 66.9559L41.6058 72.3486C41.667 72.4437 41.7078 72.5504 41.7256 72.662C41.7435 72.7735 41.738 72.8876 41.7096 72.997C41.6812 73.1064 41.6304 73.2087 41.5605 73.2976C41.4906 73.3864 41.403 73.4599 41.3033 73.5134C41.1763 73.6007 41.0251 73.646 40.871 73.6428Z'
                fill='#0065FF'
            />
            <path
                d='M53.6652 73.6427C53.5265 73.6416 53.3903 73.6054 53.2694 73.5375C53.1484 73.4696 53.0467 73.3722 52.9737 73.2545C52.9078 73.1612 52.861 73.0558 52.8362 72.9444C52.8114 72.833 52.809 72.7178 52.8291 72.6055C52.8492 72.4931 52.8914 72.3859 52.9533 72.2899C53.0152 72.194 53.0956 72.1112 53.1898 72.0465L61.6184 66.4381L58.4199 61.0885C58.3579 60.9901 58.3164 60.8801 58.2981 60.7652C58.2798 60.6504 58.2849 60.533 58.3131 60.4202C58.3414 60.3073 58.3922 60.2014 58.4626 60.1086C58.5329 60.0159 58.6213 59.9383 58.7224 59.8806C58.9203 59.7796 59.1483 59.7546 59.3634 59.8102C59.5785 59.8659 59.7657 59.9984 59.8895 60.1826L63.5203 66.2655C63.6357 66.4556 63.6732 66.6829 63.6248 66.8999C63.5765 67.1169 63.4462 67.3069 63.2609 67.4304L54.1839 73.4702C54.0359 73.5851 53.8528 73.646 53.6652 73.6427Z'
                fill='#0065FF'
            />
            <path
                d='M43.767 76.3175C43.5794 76.3208 43.3964 76.2599 43.2483 76.1449C43.1524 76.0809 43.0711 75.9975 43.0097 75.9001C42.9483 75.8026 42.9081 75.6934 42.8918 75.5794C42.8755 75.4655 42.8834 75.3494 42.915 75.2387C42.9467 75.128 43.0013 75.0251 43.0754 74.9369L55.9129 57.4214C55.981 57.3308 56.0663 57.2544 56.164 57.1967C56.2617 57.139 56.3698 57.101 56.4822 57.085C56.5946 57.0689 56.709 57.0752 56.819 57.1033C56.929 57.1314 57.0323 57.1809 57.1231 57.2489C57.214 57.3168 57.2905 57.402 57.3483 57.4995C57.4062 57.597 57.4442 57.7049 57.4602 57.8171C57.4763 57.9293 57.4701 58.0435 57.4419 58.1533C57.4137 58.263 57.3641 58.3662 57.296 58.4568L44.4586 75.9723C44.3759 76.0771 44.271 76.1624 44.1514 76.2221C44.0319 76.2817 43.9006 76.3143 43.767 76.3175Z'
                fill='#0065FF'
            />
        </g>
        <defs>
            <clipPath id='clip0_1704_2761'>
                <rect
                    width='96'
                    height='89.4757'
                    fill='white'
                    transform='translate(0.5)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default UploadFileImage;
